export default __webpack_public_path__ + "static/media/section_banner.a17d41a5.png";